var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row justify-content-center designs--foreground",
      attrs: { id: "maze-themes" }
    },
    [
      _vm.searching
        ? _c("div", { staticClass: "col-12" }, [_vm._m(0)])
        : _vm._l(_vm.posts, function(post) {
            return _c(
              "a",
              {
                staticClass: "col-12 col-md-4 card card--theme",
                attrs: { href: post.custom.link }
              },
              [
                _c("div", { staticClass: "card__inner bg-white" }, [
                  post.custom.image.image
                    ? _c(
                        "div",
                        {
                          staticClass: "card__image background-image",
                          style: {
                            backgroundImage:
                              "url('" + post.custom.image.image + "')"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "sr-only",
                            attrs: { src: post.custom.image.image }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card__content card__content--theme-wave text-center"
                    },
                    [
                      post.custom.icon
                        ? _c("div", {
                            staticClass:
                              "card__icon circle circle--icon svg--white",
                            class: post.custom.colour,
                            domProps: { innerHTML: _vm._s(post.custom.icon) }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h4", {
                        staticClass: "card__title text-bold",
                        domProps: { innerHTML: _vm._s(post.post_title) }
                      })
                    ]
                  )
                ])
              ]
            )
          }),
      _vm._v(" "),
      _vm.noResults
        ? _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "col-12 text-center" }, [
              _vm._v("\n      " + _vm._s(_vm.noResults) + "\n    ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPagination
        ? _c(
            "div",
            { staticClass: "col-12 mt-6", attrs: { "animate-up": "" } },
            [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  !_vm.isLoadingNextPage
                    ? _c("button", {
                        staticClass: "btn btn--solid btn--grey-blue-light",
                        attrs: { type: "button" },
                        domProps: { innerHTML: _vm._s(_vm.pagination.label) },
                        on: { click: _vm.loadMoreTrigger }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isLoadingNextPage
                    ? _c("infinite-loading", {
                        ref: "infiniteLoading",
                        staticClass: "pagination js-load-more-pagination",
                        attrs: { identifier: _vm.infiniteId },
                        on: { infinite: _vm.loadMoreHandler }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 text-center filters__searching" }, [
      _c("div", { staticClass: "spinner" }, [
        _c("div", { staticClass: "bounce1" }),
        _vm._v(" "),
        _c("div", { staticClass: "bounce2" }),
        _vm._v(" "),
        _c("div", { staticClass: "bounce3" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filters__searching-text sm" }, [
        _vm._v("Searching...")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /builds/hatchet/creativemazes/wp-content/themes/creative-mazes-theme/node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":"babel-loader"}}!/builds/hatchet/creativemazes/wp-content/themes/creative-mazes-theme/node_modules/vue-loader/lib?{"loaders":{"js":"babel-loader"}}!./scripts/vue/MazeThemes/MazeThemes.vue?vue&type=template&id=216b446b&
// module id = 51
// module chunks = 0